var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeMarkdown = void 0;
var TurndownService = __importStar(require("turndown"));
var turndownService = TurndownService.default({ headingStyle: 'atx' });
function escapeMarkdown(input) {
    var content = turndownService.escape(input);
    content = content === null || content === void 0 ? void 0 : content.replace(/\n/g, '  \n');
    content = content === null || content === void 0 ? void 0 : content.replace(/&#?\w+;?/g, function (value) { return "`" + value + "`"; });
    return content;
}
exports.escapeMarkdown = escapeMarkdown;
//# sourceMappingURL=MarkdownHtml.js.map